// Hooks
import { useEffect } from "react";
// GlobalStyles
import { GlobalStyles } from "./styles/global-styles";
// Components
import Navbar from "./components/Navbar/Navbar";
import Home from "./pages/home/Home";
import About from "./pages/about/About";
import Skills from "./pages/skills/Skills";
import ButtonTop from "./components/ButtonTop";
import Projects from "./pages/projects/Projects";
import Contact from "./pages/contact/Contact";
import Footer from "./components/Footer/Footer";
// Router
import { BrowserRouter as Router } from "react-router-dom";
// styled
import { ThemeProvider } from "styled-components";
import { theme } from "./styles/theme";
// react reveal
import scrollreveal from "scrollreveal";

function App() {
  useEffect(() => {
    const sr = scrollreveal({
      origin: "left",
      distance: "80px",
      duration: 2000,
      reset: true,
    });
    sr.reveal(
      `
      #about,
      #skills,
      #projects,
      #contact
      `,
      {
        opacity: 0,
        interval: 300,
      }
    );
  }, []);

  return (
    <>
      <ThemeProvider theme={theme}>
        <Router>
          <Navbar />
          <Home />
          <About />
          <Skills />
          <Projects />
          <Contact />
          <ButtonTop />
          <Footer />
          <GlobalStyles />
        </Router>
      </ThemeProvider>
    </>
  );
}

export default App;
